const Icon = () => {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.customColors.iconColor
        })
      }
    }
  }
}

export default Icon